// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2cv4Z","signatureButtonsRight":"ModalSign_signatureButtonsRight__H0VWw"};